import { useEffect, useState } from "react";
import { WatchoViewList } from "./WatchoViewList/WatchoViewList";


export const DownloadApp = ({os}) => {
    
    return(
        <div className="watchoViewListWrapper">
            <WatchoViewList />
            <div className="watchoAppDownload">
                <p>From never seen before content to <br /> 
<span>Live Sports, top movies & series across popular OTT apps</span> — <br />
whatever you're in the mood for, stream them all with Watcho</p>
                <div className="appDownloadButton d-none d-lg-block">
                    <a href="https://play.google.com/store/search?q=watcho&c=apps&hl=en" target="_blank">
                        <img src="../Images/WatchoDownloadLP/playStore.png"/>
                    </a>
                    <a href="https://apps.apple.com/in/app/watcho-new-web-series-livetv/id1440733653" target="_blank">
                        <img src="../Images/WatchoDownloadLP/appStore.png"/>
                    </a>
                </div>
                <div className="watchoDownloadBtn d-block d-lg-none">
                    {os === "iOS" ? (
                        <a className="btn btn-primary w-100 w-md-auto" target="_blank" href="https://lets.watcho.com/BshTkVATkTb">Download the App Now</a>
                    ) : (
                        <a className="btn btn-primary w-100 w-md-auto" target="_blank" href="https://lets.watcho.com/BshTkVATkTb">Download the App Now</a>
                    )}
                </div>
            </div>
        </div>
        
    );
}